export const userAgentIsPhonelike = () => {
  return Boolean(navigator.userAgent.match(/iphone|android/gi)) || false;
};
